// tenant/TenantNavbar.tsx
import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { useTenantAuth } from '../context/tenantAuth';

const linkBase: React.CSSProperties = {
  textDecoration: 'none',
  color: 'white',
  padding: '8px 12px',
  borderRadius: 6,
  marginRight: 8,
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: 14,
};

const activeStyle: React.CSSProperties = {
  backgroundColor: '#7B1FA2',
};

const TenantNavbar: React.FC = () => {
  const { logout } = useTenantAuth();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await logout();
      history.push('/'); // back to marketing site
    } catch (err) {
      console.error('Error logging out tenant:', err);
    }
  };

  return (
    <nav
      style={{
        width: '100%',
        padding: '10px 20px',
        backgroundColor: '#261136',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
      }}
    >
      <div>
        <NavLink
          exact
          to="/tenant/home"
          style={linkBase}
          activeStyle={activeStyle}
        >
          Home
        </NavLink>

        <NavLink
          to="/tenant/orders"
          style={linkBase}
          activeStyle={activeStyle}
        >
          Orders
        </NavLink>
        <NavLink
          to="/tenant/menu"
          style={linkBase}
          activeStyle={activeStyle}
        >
          Account
        </NavLink>
      </div>

      <button
        onClick={handleLogout}
        style={{
          ...linkBase,
          marginRight: 0,
          backgroundColor: 'transparent',
          border: '1px solid #7B1FA2',
          cursor: 'pointer',
        }}
      >
        Log out
      </button>
    </nav>
  );
};

export default TenantNavbar;
